module.exports = __webpack_public_path__ + "images/heroimagemob430a9a134da97937fee85826115cc314.png";